// extracted by mini-css-extract-plugin
module.exports = {"loading":"_3Oj1cTO7AHOkijwjNhMGf","full":"w01uu-lmTr4UD2I4cj7GT","small":"_2bFHaO61sBhY9Fu5JLcxqN"};